/* @flow */

import { compose } from 'ramda';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  getEventName,
  getEventSignupCodeLabel,
  getEventSignupCodeLegend,
  getEventSignupCodePlaceholder,
  getEventSignupCodeText,
} from '@e180/domain/lib/event/util';

import SignupActivationFormDumb from './SignupActivationFormDumb';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  handleSubmit: (Object) => Promise<any>,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const mapStateToProps = (
  state: State,
  { handleSubmit, intl }: Props,
): Object => {
  const { locale } = intl;
  const event = getEventSafely(state);

  return {
    handleSubmit,
    eventName: getEventName(event, locale),
    label: getEventSignupCodeLabel(event, locale),
    legend: getEventSignupCodeLegend(event, locale),
    placeholder: getEventSignupCodePlaceholder(event, locale),
    note: getEventSignupCodeText(event, locale),
  };
};

export default compose(
  injectIntl,
  connect(mapStateToProps),
)(SignupActivationFormDumb);
